export default "https://cdn-static.gokick.com/assets/6ff5832d0d355fee068eb0a1603b37a2d61221c6/images/sleep-tangerine.755ecdb6db700f77bb8084d276871abe.png";